export default "__VITE_ASSET__DyOcFZvq__"